(function (Drupal, once) {
  Drupal.behaviors.testimonialCarousel = {
    selector: '.testimonial-splide',

    attach: function attach() {
      const carousels = once('testimonial-carousel-once', this.selector);

      if (carousels.length <= 0) {
        return;
      }

      carousels.forEach(carousel => {
        const childs = carousel.querySelectorAll('.splide__slide');

        if (childs.length > 1) {
          const splide = new Splide(carousel, {
            perPage: 1,
            type  : 'fade',
            drag: true,
            rewind: true,
            pagination: false,
          });
          splide.mount();
        }
      });
    }
  }
})(Drupal, once);
